import { render, staticRenderFns } from "./ImportedUsersOrders.vue?vue&type=template&id=66353afc&scoped=true&"
import script from "./ImportedUsersOrders.vue?vue&type=script&lang=ts&"
export * from "./ImportedUsersOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66353afc",
  null
  
)

export default component.exports